const zapIds = {
  "coloring-book": "2376yjk",
  "civics-poster": "ua8aa2l",
  "us-presidents": "2376cg8",
  "biblical-stories": "uik3wop",
  "parent-action-guide": "usibo9e",
  "constitution-crosswalk": "utujj12",
  "woke-education": "2fbbfa6",
  "trailblazers": "2pwf883",
  "cash-course": "212hg0v",
  "tip-Off": "u21086u",
  "ten-commandments": "2qrstud"
}
const emailFormContainer = document.querySelector(".email-form__container");
const submitLink = emailFormContainer.dataset.afterSubmit;

const changeFormStatus = (status, id) => {
  document.querySelector(`#email-form__${id}`).setAttribute("data-form-status", status);
};

function getParam(name) {
  return new URLSearchParams(window.location.search).get(name);
}

async function submitLeadToXano(formId) {
  const form = document.querySelector(`#email-form__${formId}`);

  const email = form.querySelector("input[name='Emails']").value;
  const sheetName = form.dataset.sheetName;
  const afterSubmit = form.dataset.afterSubmit;

  try {
    const res = await fetch(`https://x8ki-letl-twmt.n7.xano.io/api:dbHwlkDY/prageru-email-collection`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        Email: email,
        Campaign_ID: sheetName,
        Zap_ID: zapIds[sheetName]
      })
    });

    if (!res.ok) throw new Error("Lead not saved");

    changeFormStatus("success", formId);
    window.location.href = `/pages/prageru-thank-you-page?resourceLink=${afterSubmit}`;
  } catch (err) {
    console.error("Lead failed", err);
    changeFormStatus("error", formId);
  }
}

const emailSubmitEl = document.querySelectorAll(".email-submit__btn");

for (let btn of emailSubmitEl) {
  btn.addEventListener("click", () => {
    const formId = btn.dataset.formId;
    changeFormStatus("loading", formId);
    submitLeadToXano(formId);
  });
}
